import AnchorAPIError from './AnchorAPIError';

const getEndpointUrl = (isCacheBust: boolean) => {
  const timestampParam = isCacheBust ? `?timestamp=${Date.now()}` : '';
  return `/api/sourceaudio/audiolibrary${timestampParam}`;
};

export const fetchAudioLibrary = async (isCacheBust: boolean) => {
  try {
    const response = await fetch(getEndpointUrl(isCacheBust), {
      method: 'GET',
      credentials: 'same-origin',
    });
    const json = await response.json();
    return json;
  } catch (err) {
    throw new AnchorAPIError(err);
  }
};
